import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 5000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    console.log('Request URL:', config.url)
    console.log('Full URL:', config.baseURL + config.url)
    
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Token'] = token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 添加时间戳转换函数
function formatTimestamp(timestamp) {
  if (!timestamp) return ''
  const date = new Date(timestamp * 1000) // 转换为毫秒
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

// 递归处理对象中的时间戳
function processData(data) {
  if (Array.isArray(data)) {
    return data.map(item => processData(item))
  }
  
  if (typeof data === 'object' && data !== null) {
    const processed = {}
    for (const key in data) {
      if (key === 'updatetime' && typeof data[key] === 'number') {
        processed[key] = formatTimestamp(data[key])
      } else {
        processed[key] = processData(data[key])
      }
      if (key === 'createtime' && typeof data[key] === 'number') {
        processed[key] = formatTimestamp(data[key])
      } else {
        processed[key] = processData(data[key])
      }
    }
    return processed
  }
  
  return data
}

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    console.log('响应数据:', res)
    
    // 处理成功响应
    if (res.code === 1) {
      // 处理数据中的时间戳
      if (res.data) {
        res.data = processData(res.data)
      }
      return res
    }
    
    // token 过期或无效
    if (res.code === 401) {
      Message({
        message: '登录已过期，请重新登录',
        type: 'error',
        duration: 3000
      })
      localStorage.removeItem('token')
      if (router.currentRoute.path !== '/login') {
        router.push('/login')
      }
      return Promise.reject(new Error('登录已过期'))
    }
    
    // 其他错误
    if(res.msg === '没有收藏') {}else {
      Message({
    
        message: res.msg || '错误',
        type: 'error',
        duration: 5000
      })
    }
    
    return Promise.reject(new Error(res.msg || '错误'))
  },
  error => {
    // 处理 HTTP 错误状态
    if (error.response) {
      switch (error.response.status) {
        case 401:
          Message({
            message: '登录已过期，请重新登录',
            type: 'error',
            duration: 3000
          })
          localStorage.removeItem('token')
          // if (router.currentRoute.path !== '/') {
          //   console.log(11111,router.currentRoute.path)
          //   router.push('/')
          // }
          break
        case 403:
          Message({
            message: '没有权限访问',
            type: 'error',
            duration: 3000
          })
          break
        case 404:
          Message({
            message: '请求的资源不存在',
            type: 'error',
            duration: 3000
          })
          break
        case 500:
          Message({
            message: '服务器错误',
            type: 'error',
            duration: 3000
          })
          break
        default:
          Message({
            message: error.message,
            type: 'error',
            duration: 3000
          })
      }
    }
    return Promise.reject(error)
  }
)

// 封装请求方法
export const http = {
  post(url, data) {
    return service({
      url,
      method: 'post',
      data
    })
  },

}

export default service 